import CircularProgress from '@mui/material/CircularProgress';
import { styled } from '@mui/material/styles'

const FullPageCircularProgress = styled(CircularProgress)`
  position: fixed;
  top: 50%;
  left: 50%;
`;

export default FullPageCircularProgress;
